import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

enum CustomerType {
	PRIVATE = 0,
	COMPANY = 1,
}

@Component({
	selector: 'app-event-business-payments-table-filters',
	templateUrl: './event-business-payments-table-filters.component.html',
	styleUrls: ['./event-business-payments-table-filters.component.css'],
})
export class EventBusinessPaymentsTableFiltersComponent extends FiltersComponent {
	@Input() organization: Array<any>;
	@Input() profile: Array<any>;
	filters = {
		date_from: null,
		date_to: null,
		search: null,
		client: [],
		company: [],
		selectedFilterCustomerKind: CustomerType.COMPANY,
		customerType: null,
	};
	customerType = CustomerType;

	protected filtersDefinition = {
		client: {
			type: 'string',
			isArray: true,
		},
		company: {
			type: 'string',
			isArray: true,
		},
		selectedFilterCustomerKind: {
			type: 'number',
			isArray: false,
		},
	};

	changeSelectedData(value: boolean): void {
		if (value) {
			this.filters.company = [];
		}
		if (!value) {
			this.filters.client = [];
		}
	}
}
